export default "__VITE_ASSET__DxycYU7p__"